// This is the React component for Section 11 ("Ready to Grow" CTA)
// DESKTOP: Sticky image column, scrolling text column with 4 fluff images.
// MOBILE: Stacked layout with 1 low-opacity fluff image behind the text.

import React, { useLayoutEffect, useRef } from "react";
import "./Section11.css"; // We will create this file next
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Import the images for this section
import ctaImg from "../../../assets/images/Ctaimg.png"; // Nat Run Group-0321 -2.png
import yukonLogo from "../../../assets/images/Yukon.png";
import poweredByGreenLogo from "../../../assets/images/Poweredbygreen.png";
import fluffImg from "../../../assets/images/Fluff1.png"; // FLY FLUFF

gsap.registerPlugin(ScrollTrigger);

// --- Component Text ---
const title = "Ready to Grow With Us?";
const paragraph =
  "Join our community to get full access to all 15 lesson plans, the activity cards, and the resources you need to plant and nurture a program in your area.";

// --- React Component ---
function Section11() {
  const sectionRef = useRef(null);
  const imageColRef = useRef(null);
  const textColRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Simple waterfall reveal for the two columns
      gsap.fromTo(
        [imageColRef.current, textColRef.current],
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2, // Image first, then text
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 75%",
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="section-11" ref={sectionRef}>
      <div className="section-11-container">
        
        {/* --- Column 1: Image --- */}
        {/* On mobile, this is just the top image. */}
        {/* On desktop, this is the sticky column. */}
        <div className="section-11-image-column" ref={imageColRef}>
          <img src={ctaImg} alt="Group of people running" className="section-11-cta-image" />
        </div>

        {/* --- Column 2: Text Content --- */}
        {/* On mobile, this is the content block below the image. */}
        {/* On desktop, this is the scrolling column. */}
        <div className="section-11-text-column" ref={textColRef}>
          
          {/* --- Decorative Fluff Images --- */}
          {/* CSS will show/hide these. On mobile, only fluff-1 is shown. */}
          <img src={fluffImg} alt="" className="section-11-fluff fluff-1" />
          <img src={fluffImg} alt="" className="section-11-fluff fluff-2" />
          <img src={fluffImg} alt="" className="section-11-fluff fluff-3" />
          <img src={fluffImg} alt="" className="section-11-fluff fluff-4" />

          {/* This inner container holds the content and sits
              ON TOP of the fluff images */}
          <div className="section-11-text-content">
            <h2 className="section-11-title">{title}</h2>
            <p className="section-11-paragraph">{paragraph}</p>
            
            <a href="#signup" className="section-11-button">
              BECOME A MEMBER
            </a>
            
            <div className="section-11-sponsors">
              <img src={yukonLogo} alt="Yukon Lottery" className="sponsor-logo" />
              <img src={poweredByGreenLogo} alt="Powered by Green" className="sponsor-logo" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Section11;